import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles<{
  searchNow?: boolean
  isAnyFilterApplied?: boolean
}>()(theme => ({
  root: {
    display: 'flex',
    minWidth: theme.spacing(83),
    padding: theme.spacing(4, 5),
    flexDirection: 'column',
    alignItems: 'flex-start',
    borderRadius: '8px',
    gap: theme.spacing(2),
    background: theme.palette.bg.main,
    boxSizing: 'border-box',
    margin: theme.spacing(-4),
    height: 'calc(100vh - 65px)',
  },
}))
